var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.68 12.32a16.76 16.76 0 0 0 4 2.98l2.63-2.67 4.76 1.1c.5.11.93.41.93.92v4.71a.4.4 0 0 1-.32.4c-4.46.94-10.02-.88-14.29-5.15C1.13 10.34-.7 4.78.24.3a.4.4 0 0 1 .4-.3h4.7c.52 0 .82.43.93.93l1.1 4.76L4.7 8.31a16.3 16.3 0 0 0 2.98 4.01Z",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;